import { ApiRequest, GetBaseServiceFunctions } from '../baseService'

const BaseRoute = 'app/document-types'
const baseFunctions = GetBaseServiceFunctions(BaseRoute)
const API = { ...baseFunctions }

export default API
